import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesRefreshService {
  private refreshActivitiesSource = new Subject<void>();
  refreshActivities$ = this.refreshActivitiesSource.asObservable();

  triggerRefresh() {
    this.refreshActivitiesSource.next();
  }
}
